export const ROUTES = {
  // Authentication
  LOGIN: '/login',
  LOGOUT: '/logout',
  SUCCESSFUL_LOGIN: '/success',

  //Dashboard/Home
  HOME: '/',

  // Sales Targets
  SALES_TARGETS: '/rewards/sales-targets',
  SALES_TARGET_ADD: '/rewards/sales-target/add',
  SALES_TARGET_PRODUCTS: '/rewards/sales-target/products',
  SALES_TARGET_DISPLAY_CONTENT: '/rewards/sales-target/display-content',
  SALES_TARGET_REVIEW: '/rewards/sales-target/review',
  SALES_TARGET_DETAIL: '/rewards/sales-target/:id',

  //Activity Routes
  ACTIVITIES: '/rewards/activities',
  ACTIVITIES_CONFIGURE: '/rewards/activities/configure/:type?',
  ACTIVITY_ADD: '/rewards/activity/add',
  ACTIVITY_REVIEW: '/rewards/activity/review',
  ACTIVITY_VIEW: '/rewards/activity/:id',

  //Point Multiplier
  POINT_MULTIPLIER: '/rewards/point-multiplier',
  POINT_MULTIPLIER_CREATE: '/rewards/point-multiplier/create',
  POINT_MULTIPLIER_PRODUCTS: '/rewards/point-multiplier/products',
  POINT_MULTIPLIER_REVIEW: '/rewards/point-multiplier/review',
  POINT_MULTIPLIER_VIEW: '/rewards/point-multiplier/:id',

  //Bulk Modifiers
  BULK_POINT_MODIFIERS: '/rewards/bulk-modifiers',
  BULK_POINT_MODIFIER_CREATE: '/rewards/bulk-point-modifier/create',
  BULK_POINT_MODIFIER_REVIEW: '/rewards/bulk-point-modifier/review',

  // Products
  PRODUCT_FULLFILLMENT: '/products/fullfillment',
  PRODUCT_REVIEW: '/products/product-detail/:id',

  //Store routes
  STORE_NAME: '/store-name',
  STORE_DETAILS: '/store-details',
  STORE_LIST: '/store-list',

  //Club+
  CLUB_HOME: '/rewards/club-plus',
  CREATE_TIER: '/rewards/club-plus/create-tier',

  ORDERS: '/orders',
  TABLE: '/table', // for dyanmic table testing
  ORDER_LIST: '/order-list',
  ORDER_ITEM: '/order-item',
  ORDER_ITEM_OVERVIEW: '/rewards/order/item-overview',
  ORDER_DETAIL_PAGE: '/order-detail',
  ORDER_PRICE_INFO: '/order-price-information',
  ORDER_SOLD_TO: '/order-soldTo',
  ORDER_REWARDS: '/order-rewards',
  LIST_NBAS: '/nbas',

  CREATE_JOURNEY: '/create',
  CREATE_NBA: '/create',
  EDIT_JOURNEY: '/journey/:id',
  EDIT_NBA: '/nba/:id',
  NBA_REPORTS: '/reports/nba-store',
  TASK_REPORTS: '/reports/task-store',
  SETTINGS: '/settings',
  EVENTS: '/events',
  ERROR: '/error',
  ERROR_403: '/error/403',
  ERROR_500: '/error/500',
  TEST: '/test',
  IMAGE: 'image',
}
